var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_Search_Filled",
    transform: "translate(-978 91)",
    className: "st0",
    d: "M993.5-77h-0.7940063l-0.276001-0.2740479 C993.4431152-78.4488525,994.0003052-79.9486084,994-81.5c0-3.5898438-2.9101562-6.5-6.5-6.5s-6.5,2.9101562-6.5,6.5 s2.9101562,6.5,6.5,6.5c1.5504761,0.0010986,3.0498047-0.5546875,4.2249756-1.56604l0.276001,0.2740479V-75.5l5,4.9909668 L998.4899902-72l-4.9879761-5H993.5z M987.5-77c-2.4852905,0-4.5-2.0147705-4.5-4.5l0,0c0-2.4852295,2.0147095-4.5,4.5-4.5 s4.5,2.0147705,4.5,4.5S989.9852905-77,987.5-77L987.5-77z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/Icon_Search.b588f420b0d3154fdb7f632113a0bb20.svg";
export { ForwardRef as ReactComponent };